// extracted by mini-css-extract-plugin
export default {"tabListItem":"styles_tabListItem__Nx18M"};